// extracted by mini-css-extract-plugin
export default {"container":"CentralPanel_container__rmO9v"};